export default {"src":"__ASTRO_ASSET_IMAGE__BCuERN_6__","width":260,"height":228,"format":"jpg"}